/** AND-joins required reco combination groups — mirrors `overview.sql.ts` search split. */
export const TOPIC_DETAIL_AND_DELIMITER = "***";

/** OR-joins alternative combinations within one group — mirrors `overview.sql.ts` option split. */
export const TOPIC_DETAIL_OR_DELIMITER = "|||";

export const HOOK_POST_HOOK_TIME_FRAME = "Hook & Post-Hook";

/**
 * When a topic spans Hook and Post-Hook sections, expand the combination so reco
 * matches both hook lengths — ports Retool `clickMixChartOverview` OR_DELIMITER logic.
 */
export function expandHookPostHookCombination(
  combination: string,
  featureTimeFrame: string,
): string {
  if (featureTimeFrame !== HOOK_POST_HOOK_TIME_FRAME) return combination;
  if (combination.includes("10_sec")) {
    return `${combination}${TOPIC_DETAIL_OR_DELIMITER}${combination.replace("10_sec", "3_sec")}`;
  }
  if (combination.includes("3_sec")) {
    return `${combination}${TOPIC_DETAIL_OR_DELIMITER}${combination.replace("3_sec", "10_sec")}`;
  }
  return combination;
}

/**
 * Build the `search` param for topic-detail Examples/Fatigue queries.
 * Retool parity: clicked combination (+ Hook/Post-Hook expansion) AND-joined with
 * focus combinations. v1 passes an empty focus list until Nexus has `focus_entries`.
 */
export function buildTopicDetailSearch(
  clickedCombination: string | null,
  featureTimeFrame: string,
  focusCombinations: string[] = [],
): string {
  if (!clickedCombination) {
    return buildTopicDetailSearchFromReportRows([], focusCombinations);
  }
  return buildTopicDetailSearchFromReportRows(
    [{ combination: clickedCombination, feature_time_frame: featureTimeFrame }],
    focusCombinations,
  );
}

/** OR-joins all combinations for rows sharing a chart topic (aggregated bar parity). */
export function buildTopicDetailSearchFromReportRows(
  reportRows: ReadonlyArray<{ combination: string; feature_time_frame: string }>,
  focusCombinations: string[] = [],
): string {
  const topicOptions = new Set<string>();
  for (const row of reportRows) {
    if (!row.combination) continue;
    const expanded = expandHookPostHookCombination(row.combination, row.feature_time_frame);
    for (const part of expanded.split(TOPIC_DETAIL_OR_DELIMITER)) {
      if (part) topicOptions.add(part);
    }
  }

  const parts = [...focusCombinations.filter(Boolean)];
  if (topicOptions.size > 0) {
    parts.push([...topicOptions].join(TOPIC_DETAIL_OR_DELIMITER));
  }

  const unique = [...new Set(parts)];
  return unique.length > 0 ? unique.join(TOPIC_DETAIL_AND_DELIMITER) : "All";
}
